import { render, staticRenderFns } from "./LabelManagement.vue?vue&type=template&id=bf926f26&scoped=true&"
import script from "./LabelManagement.vue?vue&type=script&lang=js&"
export * from "./LabelManagement.vue?vue&type=script&lang=js&"
import style0 from "./LabelManagement.vue?vue&type=style&index=0&id=bf926f26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf926f26",
  null
  
)

export default component.exports